// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SetGroupRoleForWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
  role: PrivateSchemaTypes.WorkspaceRoleEnum;
}>;


export type SetGroupRoleForWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { setGroupRole?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'GroupWorkspaceModel' }
      & Pick<PrivateSchemaTypes.GroupWorkspaceModel, 'role'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type RemoveGroupFromWorkspaceAccessMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveGroupFromWorkspaceAccessMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { removeGroup?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'GroupModelGQLBase' }
      & Pick<PrivateSchemaTypes.GroupModelGqlBase, 'id'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type SetUserRoleForWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  role: PrivateSchemaTypes.WorkspaceRoleEnum;
}>;


export type SetUserRoleForWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { setUserRole?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserWorkspaceModel' }
      & Pick<PrivateSchemaTypes.UserWorkspaceModel, 'role'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type RemoveUserFromWorkspaceAccessMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveUserFromWorkspaceAccessMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { removeUser?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type SetWorkspaceOpenessMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  is_open: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type SetWorkspaceOpenessMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { setIsOpen?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);


export const SetGroupRoleForWorkspaceDocument = gql`
    mutation setGroupRoleForWorkspace($workspaceId: PositiveInt!, $groupId: PositiveInt!, $role: WorkspaceRoleEnum!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      setGroupRole(groupId: $groupId, role: $role) {
        role
      }
    }
  }
}
    `;
export type SetGroupRoleForWorkspaceMutationFn = Apollo.MutationFunction<SetGroupRoleForWorkspaceMutation, SetGroupRoleForWorkspaceMutationVariables>;

/**
 * __useSetGroupRoleForWorkspaceMutation__
 *
 * To run a mutation, you first call `useSetGroupRoleForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGroupRoleForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGroupRoleForWorkspaceMutation, { data, loading, error }] = useSetGroupRoleForWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      groupId: // value for 'groupId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetGroupRoleForWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetGroupRoleForWorkspaceMutation, SetGroupRoleForWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetGroupRoleForWorkspaceMutation, SetGroupRoleForWorkspaceMutationVariables>(SetGroupRoleForWorkspaceDocument, options);
      }
export type SetGroupRoleForWorkspaceMutationHookResult = ReturnType<typeof useSetGroupRoleForWorkspaceMutation>;
export type SetGroupRoleForWorkspaceMutationResult = Apollo.MutationResult<SetGroupRoleForWorkspaceMutation>;
export type SetGroupRoleForWorkspaceMutationOptions = Apollo.BaseMutationOptions<SetGroupRoleForWorkspaceMutation, SetGroupRoleForWorkspaceMutationVariables>;
export const RemoveGroupFromWorkspaceAccessDocument = gql`
    mutation removeGroupFromWorkspaceAccess($workspaceId: PositiveInt!, $groupId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      removeGroup(groupId: $groupId) {
        id
      }
    }
  }
}
    `;
export type RemoveGroupFromWorkspaceAccessMutationFn = Apollo.MutationFunction<RemoveGroupFromWorkspaceAccessMutation, RemoveGroupFromWorkspaceAccessMutationVariables>;

/**
 * __useRemoveGroupFromWorkspaceAccessMutation__
 *
 * To run a mutation, you first call `useRemoveGroupFromWorkspaceAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupFromWorkspaceAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupFromWorkspaceAccessMutation, { data, loading, error }] = useRemoveGroupFromWorkspaceAccessMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemoveGroupFromWorkspaceAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGroupFromWorkspaceAccessMutation, RemoveGroupFromWorkspaceAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveGroupFromWorkspaceAccessMutation, RemoveGroupFromWorkspaceAccessMutationVariables>(RemoveGroupFromWorkspaceAccessDocument, options);
      }
export type RemoveGroupFromWorkspaceAccessMutationHookResult = ReturnType<typeof useRemoveGroupFromWorkspaceAccessMutation>;
export type RemoveGroupFromWorkspaceAccessMutationResult = Apollo.MutationResult<RemoveGroupFromWorkspaceAccessMutation>;
export type RemoveGroupFromWorkspaceAccessMutationOptions = Apollo.BaseMutationOptions<RemoveGroupFromWorkspaceAccessMutation, RemoveGroupFromWorkspaceAccessMutationVariables>;
export const SetUserRoleForWorkspaceDocument = gql`
    mutation setUserRoleForWorkspace($workspaceId: PositiveInt!, $userId: PositiveInt!, $role: WorkspaceRoleEnum!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      setUserRole(userId: $userId, role: $role) {
        role
      }
    }
  }
}
    `;
export type SetUserRoleForWorkspaceMutationFn = Apollo.MutationFunction<SetUserRoleForWorkspaceMutation, SetUserRoleForWorkspaceMutationVariables>;

/**
 * __useSetUserRoleForWorkspaceMutation__
 *
 * To run a mutation, you first call `useSetUserRoleForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleForWorkspaceMutation, { data, loading, error }] = useSetUserRoleForWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetUserRoleForWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserRoleForWorkspaceMutation, SetUserRoleForWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserRoleForWorkspaceMutation, SetUserRoleForWorkspaceMutationVariables>(SetUserRoleForWorkspaceDocument, options);
      }
export type SetUserRoleForWorkspaceMutationHookResult = ReturnType<typeof useSetUserRoleForWorkspaceMutation>;
export type SetUserRoleForWorkspaceMutationResult = Apollo.MutationResult<SetUserRoleForWorkspaceMutation>;
export type SetUserRoleForWorkspaceMutationOptions = Apollo.BaseMutationOptions<SetUserRoleForWorkspaceMutation, SetUserRoleForWorkspaceMutationVariables>;
export const RemoveUserFromWorkspaceAccessDocument = gql`
    mutation removeUserFromWorkspaceAccess($workspaceId: PositiveInt!, $userId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      removeUser(userId: $userId) {
        id
      }
    }
  }
}
    `;
export type RemoveUserFromWorkspaceAccessMutationFn = Apollo.MutationFunction<RemoveUserFromWorkspaceAccessMutation, RemoveUserFromWorkspaceAccessMutationVariables>;

/**
 * __useRemoveUserFromWorkspaceAccessMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromWorkspaceAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromWorkspaceAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromWorkspaceAccessMutation, { data, loading, error }] = useRemoveUserFromWorkspaceAccessMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromWorkspaceAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromWorkspaceAccessMutation, RemoveUserFromWorkspaceAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromWorkspaceAccessMutation, RemoveUserFromWorkspaceAccessMutationVariables>(RemoveUserFromWorkspaceAccessDocument, options);
      }
export type RemoveUserFromWorkspaceAccessMutationHookResult = ReturnType<typeof useRemoveUserFromWorkspaceAccessMutation>;
export type RemoveUserFromWorkspaceAccessMutationResult = Apollo.MutationResult<RemoveUserFromWorkspaceAccessMutation>;
export type RemoveUserFromWorkspaceAccessMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromWorkspaceAccessMutation, RemoveUserFromWorkspaceAccessMutationVariables>;
export const SetWorkspaceOpenessDocument = gql`
    mutation setWorkspaceOpeness($workspaceId: PositiveInt!, $is_open: Boolean!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      setIsOpen(isOpen: $is_open) {
        id
      }
    }
  }
}
    `;
export type SetWorkspaceOpenessMutationFn = Apollo.MutationFunction<SetWorkspaceOpenessMutation, SetWorkspaceOpenessMutationVariables>;

/**
 * __useSetWorkspaceOpenessMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceOpenessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceOpenessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceOpenessMutation, { data, loading, error }] = useSetWorkspaceOpenessMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      is_open: // value for 'is_open'
 *   },
 * });
 */
export function useSetWorkspaceOpenessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetWorkspaceOpenessMutation, SetWorkspaceOpenessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkspaceOpenessMutation, SetWorkspaceOpenessMutationVariables>(SetWorkspaceOpenessDocument, options);
      }
export type SetWorkspaceOpenessMutationHookResult = ReturnType<typeof useSetWorkspaceOpenessMutation>;
export type SetWorkspaceOpenessMutationResult = Apollo.MutationResult<SetWorkspaceOpenessMutation>;
export type SetWorkspaceOpenessMutationOptions = Apollo.BaseMutationOptions<SetWorkspaceOpenessMutation, SetWorkspaceOpenessMutationVariables>;